module.exports = __webpack_public_path__ + "img/top-bg4.7407d0df.png";